import { useMutation, useQuery } from "@tanstack/react-query";
import { useAxios } from "../../utils/hooks/useAxios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export const usePermissions = ({
  enabled = false,
  value,
  onSuccess,
  onError,
}) => {
  const { axiosProtected } = useAxios();

  return useQuery({
    queryKey: ["permissions/categories/by-system-ids", value],
    queryFn: () =>
      axiosProtected.post("permissions/categories/by-system-ids", {
        system_ids: [+value],
      }),
    enabled,
    onSuccess,
    onError,
  });
};

export const useCreatePermissionMutation = () => {
  const { axiosProtected } = useAxios();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: ({ groupId, payload }) =>
      axiosProtected.post(`groups/${groupId}/permissions/assign`, payload),
    mutationKey: "createPermission",
    onSuccess: () => {
      toast.success("تم إنشاء الصلاحيات بنجاح");
      navigate(-1);
    },
    onError: () => {
      toast.error("فشل إنشاء الصلاحيات");
    },
  });
};
